import { render, staticRenderFns } from "./HomePage.v2.vue?vue&type=template&id=87795614&scoped=true"
import script from "./HomePage.v2.vue?vue&type=script&lang=js"
export * from "./HomePage.v2.vue?vue&type=script&lang=js"
import style0 from "./HomePage.v2.vue?vue&type=style&index=0&id=87795614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87795614",
  null
  
)

export default component.exports